import styled from 'styled-components'
import { Input } from 'antd'

import { styleguide } from '../../constants'

import 'antd/lib/button/style/'

import IconSearch from './images/search.svg'

const { base } = styleguide

export const SearchInput = styled(Input.Search)`
  && {
    width: 100%;
    height: 4rem;
    margin:${(props) => props.indent};

    input {
      font-weight: ${base.fontWeight};
      font-size: ${base.fontSize};
      font-style: normal;
      border-radius: 2rem;
      border-color: transparent;
      padding: 1.5rem;
      background-color: #F7F7F7;

      &::-webkit-input-placeholder {
        font-style: italic;
      }
    }

    .ant-input-suffix {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .ant-input-search-icon {
      width: 2rem;
      height: 2rem;
      background: url(${IconSearch}) center center no-repeat;
      background-size: contain;
      flex-shrink: 0;

      i {
        display: none;
      }
    }

    /* Hide all default Ant Design search icons */
    .ant-input-search-icon i,
    .ant-input-search-icon .anticon,
    .ant-input-search-icon svg {
      display: none !important;
    }

    /* Hide search icon when there's a value */
    &.search-with-value .ant-input-search-icon {
      display: none;
    }

    /* Style the clear icon */
    .ant-input-clear-icon {
      color: #999;
      font-size: 14px;
      cursor: pointer;
      opacity: 1;
      visibility: visible;
      display: inline-block;
    }

    /* Ensure clear icon is visible when input has value */
    .ant-input-clear-icon-hidden {
      display: none !important;
    }
  }
`

export const SearchRectangular = styled(Input.Search)`
  && {
    width: 100%;
    height: 4rem;
    margin:${(props) => props.indent};

    input {
      font-weight: ${base.fontWeight};
      font-size: ${base.fontSize};
      font-style: normal;
      border-color: transparent;
      border-radius: 0.6rem;
      padding: 1.5rem;
      border: 1px solid #B9B9B9;
      &::-webkit-input-placeholder {
        font-style: italic;
      }
    }

    .ant-input-suffix {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .ant-input-search-icon {
      width: 2rem;
      height: 2rem;
      background: url(${IconSearch}) center center no-repeat;
      background-size: contain;
      flex-shrink: 0;

      i {
        display: none;
      }
    }

    /* Hide all default Ant Design search icons */
    .ant-input-search-icon i,
    .ant-input-search-icon .anticon,
    .ant-input-search-icon svg {
      display: none !important;
    }

    /* Hide search icon when there's a value */
    &.search-with-value .ant-input-search-icon {
      display: none;
    }

    /* Style the clear icon */
    .ant-input-clear-icon {
      color: #999;
      font-size: 14px;
      cursor: pointer;
      opacity: 1;
      visibility: visible;
      display: inline-block;
    }

    /* Ensure clear icon is visible when input has value */
    .ant-input-clear-icon-hidden {
      display: none !important;
    }
  }
`
